export const MODULE_CODES = {
    BENEFICIARY_CHILD: "Benf_ChildBenf",
    BENEFICIARY_SERVICE: "Benf_Service",
    REFERRAL_MODULE: "ReferralModule",
    BENEFICIARY_MODULE: "Benf",
    SERVICE_MASTER: "RuleMaster",
    DASHBOARD: "Dashboard",
};

export const PAGE_CODES = {
    CHILD_OVERVIEW: "ChildBenf_OVPg",
    SERVICE_OVERVIEW: "Service_OVPg",
    SERVICE_CREATE: "Service_CrPg",
    REFERRAL_LISTVIEW: "ReferralModule_LstPg",
    REFERRAL_CREATE: "ReferralModule_CrPg",
    BENEFICIARY_OVERVIEW: "Benf_OVPg",
    SERVICE_MASTER_OVERVIEW: "RuleMaster_OVPg",
    SERVICE_MASTER_EDIT: "RuleMaster_EdPg",
    DASHBOARD_VIEW: "Dashboard_LstPg",
};